import { render, staticRenderFns } from "./DashboardDocument.vue?vue&type=template&id=3770b296&"
import script from "./DashboardDocument.vue?vue&type=script&lang=js&"
export * from "./DashboardDocument.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./DashboardDocument.vue?vue&type=style&index=1&id=3770b296&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports